import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { AppBar, IconButton } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { closeSchedulerModal } from 'Context/NewClientSchedulerContext';
import { useHistory } from 'react-router-dom';
import { useMissionControlURL } from 'Hooks/useMissionControlURL';

const styles = theme => ({
  root: {
    display: 'flex',
    padding: 0,
    backgroundColor: theme.palette.facet.primaryBlueMuted,
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  backButton: {
    color: theme.palette.common.white,
    fontSize: 34,
  },
  titleText: {
    color: theme.palette.common.white,
    fontSize: 32,
  },
});

const SchedulerModalHeader = ({
  className,
  classes,
}) => {
  const history = useHistory();
  const missionControlURL = useMissionControlURL();

  const navigateToMissionControl = () => {
    closeSchedulerModal();
    history.push(missionControlURL());
  };

  return (
    <AppBar className={classNames(className, classes.root)} elevation={0}>
      <IconButton onClick={navigateToMissionControl}>
        <ArrowBackIosIcon className={classes.backButton} />
      </IconButton>
      <div className={classes.titleText}>
          Back to Mission Control
      </div>
    </AppBar>
  );
};

SchedulerModalHeader.defaultProps = {
  className: '',
};

SchedulerModalHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SchedulerModalHeader);
